var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"portal",attrs:{"fluid":""}},[_c('b-row',{staticClass:"row"},[_c('b-col',{attrs:{"id":"portal-menu"}},[_c('portalMenu')],1),_c('b-col',{attrs:{"id":"content-area"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }